module.exports = __webpack_public_path__ + "static/media/elephant.ba47ed4f.svg";